const compare = require('./compare');
const currencyFormat = require('./currencyFormat');
const intFormat = require('./intFormat');
const patchQuery = require('./patchQuery');

module.exports = {
    register (locator) {
        try {
            const Handlebars = locator.resolve('handlebars');

            Handlebars.registerHelper('compare', compare);
            Handlebars.registerHelper('currencyFormat', currencyFormat);
            Handlebars.registerHelper('intFormat', intFormat);
            Handlebars.registerHelper('json', (obj) => JSON.stringify(obj));
            Handlebars.registerHelper('patchQuery', patchQuery);
        } catch (e) {
            locator.resolve('eventBus').emit('error', e);
        }
    }
};



// WEBPACK FOOTER //
// ./services/helpers/handlebars.js